<!--仓库管理 出库 页面ID 1050100  -->
<template>
  <div>
    <el-row>
      <el-form :inline="true" class="demo-form-inline" style="padding-top:0;margin-top:0" size="medium" label-suffix="：">
        <el-form-item label="副仓" v-if="subWarehouseList && subWarehouseList.length > 1">
          <el-select v-model="searchForm.SUB_WAREHOUSE" filterable placeholder="请选择" clearable multiple collapse-tags style="width: 200px;">
            <el-option v-for="item in subWarehouseList" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
            </el-option>
          </el-select>
        </el-form-item>
        <template v-if="activeName == 'groupMealCustomer'">
          <el-form-item label="客户">
            <el-select v-model="searchForm.TC_ID" filterable placeholder="请选择" clearable>
              <el-option v-for="item in companyList" :key="item.ID" :label="item.AB_NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="项目点">
            <el-select filterable v-model="searchForm.PROJECT_ID" placeholder="请选择" clearable @change="(e) => { queryDk(e) }" multiple>
              <el-option v-for="item in points" :key="item.value" :label="item.PROJECT_TC_NAME" :value="item.PROJECT_ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="档口">
            <el-select filterable v-model="searchForm.DK_ID" placeholder="请选择档口" clearable>
              <el-option v-for="item in dkList" :key="item.ID" :label="item.NAME" :value="item.ID"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="订单ID">
            <el-input v-model="searchForm.ORDER_ID"></el-input>
          </el-form-item>
        </template>

        <el-form-item label="客户" v-else>
          <el-select v-model="searchForm.SUPPLIER" filterable placeholder="请选择" clearable>
            <el-option v-for="item in supplierList" :key="item.value" :label="item.AB_NAME" :value="item.SUPPLIER_ID">
              <span style="float: left">{{ item.AB_NAME }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单日期">
          <el-date-picker v-model="searchForm.DATE" type="daterange" range-separator="至" start-placeholder="开始日期"
            end-placeholder="结束日期"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch" :loading="loading">筛选</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <el-row>
      <el-col>
        <el-button size="medium" @click="multyOut" :loading="loading1" v-show="fun_dic[105010001]">批量出库</el-button>
        <el-button size="medium" @click="secondOut">二次出库</el-button>
        <el-button size="medium" @click="gotoManualStockOut" v-show="fun_dic[105010002]">录入出库数据(生成销售单)</el-button>
        <el-button size="medium" @click="gotoPlannedOutbound" v-show="fun_dic[105010003]">拟出库情况</el-button>
      </el-col>
    </el-row>
    <el-row style="margin-top: 20px">
      <el-col>
        <el-tabs type="border-card" @tab-click="handleTabClick" v-model="activeName">
          <el-tab-pane label="团餐客户" name="groupMealCustomer">
            <el-table border stripe :data="tableData" ref="tableData">
              <el-table-column width="55">
                <template #header>
                  <el-checkbox style="cursor: pointer" :indeterminate="selectedIdList.length > 0 && selectedIdList.length < tableData.length"
                    @change="handleSelectionChangeAll" :value="selectedIdList.length > 0 && selectedIdList.length == tableData.length" />
                </template>
                <template slot-scope="scope">
                  <el-tooltip :disabled="OUTBOUND_USE_COUNT_TYPE == 1 || scope.row.STATUS >= 4"
                    :content="( OUTBOUND_USE_COUNT_TYPE == 1 || scope.row.STATUS >= 4 ) ? '' : '只能勾选已验收订单批量出库'" style="display: inline-block">
                    <el-checkbox :disabled="OUTBOUND_USE_COUNT_TYPE == 2 && scope.row.STATUS < 4" style="cursor: pointer"
                      @change="(val) => toggleRowSelection(val, scope.row)" :value="selectedIdList.includes(scope.row.ORDER_ID)" />
                  </el-tooltip>
                </template>
              </el-table-column>
              <el-table-column prop="ORDER_ID" label="订单ID" width="80"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号"></el-table-column>
              <el-table-column prop="TC_NAME" label="团餐公司"></el-table-column>
              <el-table-column prop="PROJECT_NAME" label="项目点"></el-table-column>
              <el-table-column prop="DK_NAME" label="档口"></el-table-column>
              <el-table-column v-if="OUTBOUND_USE_COUNT_TYPE == 2" label="订单状态">
                <template slot-scope="scope">{{ scope.row.STATUS >= 4 ? '已验收' : '未验收' }}</template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="small" type="text" @click="outWarehouse(scope.row)">出库</el-button>
                  <el-button size="small" type="text" @click="noDocumentMatching(scope.row)">匹配无单据出库记录</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="供应商客户" name="supplierCustomer">
            <el-table border stripe :data="tableData">
              <el-table-column type="index" label="序号" width="50"></el-table-column>
              <el-table-column prop="ORDER_CODE" label="订单编号"></el-table-column>
              <el-table-column prop="SEND_DAY" label="送货日期"></el-table-column>
              <el-table-column prop="SUPPLIER_CLIENT_NAME" label="客户"></el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button size="small" type="text" @click="outWarehouse(scope.row)">出库</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-col>
    </el-row>
    <div class="pagination_box" style="text-align: right">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="pageSize"
        layout="total,prev, pager, next, jumper" :total="totalCount">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { stockOutFun, WMSmultyOut } from 'api/warehouseManager';
import { supplierCusFun } from 'api/customerManage';
import { haveXMDFun, selectTCFun } from 'api/sellOrder';
import { getActionFun } from 'api/login';
import date from '@/assets/common/date';
import util from '@/assets/common/util';
import http from '@/assets/common/http';

export default {
  data() {
    return {
      searchForm: {
        PROJECT_ID: [],
        DK_ID: '',
      },
      tableData: [],
      currentPage: 1,
      pageSize: 15,
      totalCount: 0,
      points: [],
      dkList: [],
      loading: false,
      // currentOrderFlag: sessionStorage.getItem('currentOrderFlag') || 0,
      supplierList: [],
      companyList: [],
      putOnArr: [],
      selectedIdList: [],
      loading1: false,
      WAREHOUSE_MODE: sessionStorage.getItem('WAREHOUSE_MODE'),
      activeName: sessionStorage.getItem('stockOutActiveName') || 'groupMealCustomer',
      PAGE_ID: '1050100', // 页面ID 一旦规定不要轻易改动
      fun_dic: { 105010001: 0, 105010002: 0, 105010003: 0 },
      subWarehouseList: JSON.parse(sessionStorage.getItem('subWarehouseList')),
      OUTBOUND_USE_COUNT_TYPE: 1,
    };
  },
  created() {
    if (JSON.parse(sessionStorage.getItem('config'))) {
      this.OUTBOUND_USE_COUNT_TYPE = JSON.parse(sessionStorage.getItem('config')).OUTBOUND_USE_COUNT_TYPE || 1;
    }
    // 这里用来在设置中设置页面展示条目，文件在setting的generalSettings中，由前端控制条目，存储于localStorage中，key为SMP_PAGE_COUNT
    this.pageSize = Number(localStorage.getItem('SMP_PAGE_COUNT')) ? Number(localStorage.getItem('SMP_PAGE_COUNT')) : 10;
    if (this.STOCK_OUT_CONDITION) {
      this.currentPage = this.STOCK_OUT_CONDITION.CURRENT_PAGE;
      this.searchForm = this.STOCK_OUT_CONDITION.CONDITION;
      this.dkList = this.STOCK_OUT_CONDITION.DK_LIST;
    } else {
      this.currentPage = 1;
    }
    this.queryData();
    this.querySupplierList();
    this.queryTitle();
    this.queryCustomer();
    this.queryBeforeFun();
  },
  computed: {
    STOCK_OUT_CONDITION() {
      return this.$store.state.STOCK_OUT_CONDITION;
    },
  },
  methods: {
    queryDk() {
      this.dkList = [];
      this.searchForm.DK_ID = '';
      if (!this.searchForm.PROJECT_ID.length) {
        return false;
      }
      const params = {
        SERVICE_ID: '10007',
        OTYPE: 4,
        SUPPLIER_ID: Number(sessionStorage.getItem('tcId')),
        PROJECTS_ID: this.searchForm.PROJECT_ID,
      };
      http.post(params).then((result) => {
        this.dkList = result;
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    gotoPlannedOutbound() {
      this.$router.push({ name: 'plannedOutbound' });
    },
    // ------------------筛选
    handleSearch() {
      this.currentPage = 1;
      this.queryData();
    },
    queryCustomer() {
      const params = {
        GET_ALL_FLAG: 1,
      };
      selectTCFun(params).then((result) => {
        if (result.length !== 0) {
          this.companyList = util.listRemoveDuplicates(result[0].company);
        } else {
          this.companyList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // ----------------------------------------------下拉框获取项目点名称
    queryTitle() {
      haveXMDFun().then((result) => {
        this.points = result.length > 0 ? result[0].project : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    handleCurrentChange(e) {
      this.currentPage = e;
      this.queryData();
    },
    // ----------------------------获取数据
    queryData() {
      this.selectedIdList = [];
      this.putOnArr = [];
      const params = {
        PAGESIZE: this.pageSize,
        PAGEINDEX: this.currentPage - 1,
      };
      if (this.searchForm.SUB_WAREHOUSE && this.searchForm.SUB_WAREHOUSE[0]) {
        params.SUPPLIER_ID_LIST = this.searchForm.SUB_WAREHOUSE;
      }
      if (this.searchForm.PROJECT_ID && this.searchForm.PROJECT_ID.length) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.ORDER_ID) {
        params.ORDER_ID = this.searchForm.ORDER_ID;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.DATE) {
        params.START_DAY = date(this.searchForm.DATE[0], '%F');
        params.END_DAY = date(this.searchForm.DATE[1], '%F');
      }
      if (this.activeName == 'supplierCustomer') {
        params.IS_SUPPLIER_CLIENT = 1;
      }
      if (this.searchForm.SUPPLIER) {
        params.SUPPLIER_CLIENT_ID = this.searchForm.SUPPLIER;
      }
      if (this.searchForm.DK_ID) {
        params.DK_ID = this.searchForm.DK_ID;
      }
      this.loading = true;
      stockOutFun(params).then((result) => {
        if (result.length !== 0) {
          this.tableData = result[0].list;
          this.totalCount = result[0].TOTAL;
          this.$store.dispatch('SET_STOCK_OUT_CONDITION', {
            CURRENT_PAGE: this.currentPage,
            CONDITION: this.searchForm,
            DATA: this.tableData,
            TOTAL_COUNT: this.totalCount,
            DK_LIST: this.dkList,
          });
        } else {
          this.tableData = [];
          this.totalCount = 0;
          this.$message.show({ text: '暂无数据', type: 'success' });
        }
        this.loading = false;
      }).catch((error) => {
        this.loading = false;
        this.$message.show({ text: error, type: 'error' });
      });
    },
    outWarehouse(row) {
      this.$router.push({ path: '/stockOutDetail/detail' });
      sessionStorage.setItem('oreder_id', row.ORDER_ID);
      sessionStorage.setItem('currentOrderFlag', Number(this.activeName == 'supplierCustomer'));
      sessionStorage.setItem('turnoverCusInfo', JSON.stringify(this.activeName == 'supplierCustomer'
        ? { company: row.SUPPLIER_CLIENT_NAME } : { company: row.TC_NAME, project: row.PROJECT_NAME, projectId: row.PROJECT_ID }));
      sessionStorage.setItem('stockOutDetailTitle', JSON.stringify(this.activeName == 'supplierCustomer'
        ? [row.ORDER_CODE, row.SEND_DAY, row.SUPPLIER_CLIENT_NAME] : [row.ORDER_ID, row.ORDER_CODE, row.TC_NAME, row.PROJECT_NAME, row.DK_NAME]));
      sessionStorage.setItem('stockOutTcId', row.TC_ID);
    },
    noDocumentMatching(row) {
      this.$router.push({ path: '/noDocumentMatching/detail' });
      sessionStorage.setItem('nDM_DK_NAME', row.DK_NAME);
      sessionStorage.setItem('nDM_PROJECT_NAME', row.PROJECT_NAME);
      sessionStorage.setItem('nDM_SEND_DAY', row.SEND_DAY);
      sessionStorage.setItem('nDM_PROJECT_ID', row.PROJECT_ID);
      sessionStorage.setItem('nDM_ORDER_ID', row.ORDER_ID);
      sessionStorage.setItem('nDM_DK_ID', row.STALL_ID);
    },
    handleTabClick(tab, event) {
      this.currentPage = 1;
      sessionStorage.setItem('stockOutActiveName', this.activeName);
      this.queryData();
    },
    querySupplierList() {
      const params = {};
      supplierCusFun(params).then((res) => {
        if (res.length !== 0) {
          this.supplierList = res[0].list;
        } else {
          this.supplierList = [];
        }
      }).catch((err) => {
        this.$message.show({ text: err, type: 'error' });
      });
    },
    secondOut() {
      this.$router.push({ name: 'secondOut' });
    },
    handleSelectionChange() {
      this.putOnArr = this.tableData.filter(({ ORDER_ID }) => this.selectedIdList.includes(ORDER_ID));
    },
    handleSelectionChangeAll(check) {
      this.selectedIdList = check ? (this.OUTBOUND_USE_COUNT_TYPE == 2 ? this.tableData.filter(({ STATUS }) => STATUS >= 4).map(({ ORDER_ID }) => ORDER_ID) : this.tableData.map(({ ORDER_ID }) => ORDER_ID)) : [];
      this.handleSelectionChange();
    },
    multyOut() {
      if (this.putOnArr.length == 0) {
        this.$message.show({ text: '请先选择需出库订单', type: 'warning' });
        return false;
      }
      const params = {
        ORDER_ARRAY: [],
        WAREHOUSE_MODE: Number(this.WAREHOUSE_MODE),
      };
      const temp_arr = this.putOnArr.map((item) => ({ ORDER_ID: item.ORDER_ID }));
      params.ORDER_ARRAY = temp_arr;
      WMSmultyOut(params).then((res) => {
        this.$message.show({ text: '出库成功', type: 'success' });
        this.handleSearch();
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 控制功能按钮
    queryBeforeFun() {
      const params = {
        PAGE_ID: this.PAGE_ID,
      };
      getActionFun(params).then((result) => {
        if (result.length !== 0) {
          this.forMenu(result, this.fun_dic);
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    forMenu(e) {
      const tmp_fun_list = e;
      for (let i = 0; i < tmp_fun_list.length; i++) {
        for (const key in this.fun_dic) {
          if (tmp_fun_list[i].FUNCTION_NUM == key) {
            this.fun_dic[key] = 1;
          }
        }
      }
    },
    gotoManualStockOut() {
      this.$router.push({ name: 'manualStockOut' });
    },
    toggleRowSelection(val, { ORDER_ID }) {
      if (val) {
        if (!this.selectedIdList.includes(ORDER_ID)) this.selectedIdList.push(ORDER_ID);
      } else {
        this.selectedIdList = this.selectedIdList.filter((x) => x != ORDER_ID);
      }
      this.handleSelectionChange();
    },
  },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/warehouseManage/stockOut.vue